/**
 * Created by nijin on 20/12/16.
 */
import {Routes, RouterModule} from '@angular/router';
import {ThingsComponent} from '../things/things.component';
import {NgModule} from '@angular/core';
import {ThingsFormComponent} from './things-form.component';
import {ThingsListComponent} from './things-list/things-list.component';
import {DescribeThingComponent} from './onboard/describe-thing.component';
import {SelectConnectionComponent} from './onboard/select-connection.component';
import {ThingOnBoardedComponent} from './onboard/done.component';
import {WizardBaseContentComponent} from './shared/wizard/wiz-base.component';
import {ThingsDetailsComponent} from './things-details/things-details.component';
import {ClonePopupComponent} from './shared/clone-popup.component';
import {WizMenu} from "./shared/wizard/wiz-menu.component";
import {WizMenuChildComponent} from "./shared/wizard/wiz-menu-child.component";
import {WizardContentComponent} from "./shared/wizard/wiz-content.component";
import {WizardComponent} from "./shared/wizard/wizard.component";
import {MapComponent} from "./things-details/location-details/map.component";
import {LocationAttributes} from "./things-details/location-details/location-attributes";
import {LocationDetailsComponent} from "./things-details/location-details/location-details.component";
import {LocationPopup} from "./things-details/location-details/location.popup";
import {OfflineThresholdComponent} from "./things-details/offline-threshold/offline-threshold.component";
import {GLOBAL_CONSTANTS} from "../global/global.constants";

const routes: Routes = [
  {
    path: '',
    component: ThingsComponent,
    children: [
      { path: '',
        component: ThingsListComponent ,
        resolve: {

        },
        data: {
          title: GLOBAL_CONSTANTS.PAGE_TITLE.THING_LIST
        }
      },
      { path: ':device/new',
        component: ThingsFormComponent,
        data: {
          title: GLOBAL_CONSTANTS.PAGE_TITLE.ON_BOARD
        }},
      { path: ':id',
        component: ThingsDetailsComponent,
        data: {
          title: GLOBAL_CONSTANTS.PAGE_TITLE.THING_DETAILS
        }
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [
  ],
})
export class ThingsRoutingModule { }

export const ROUTED_COMPONENTS = [
  ThingsComponent,
  ThingsListComponent,
  DescribeThingComponent,
  SelectConnectionComponent,
  ThingOnBoardedComponent,
  WizardBaseContentComponent,
  WizMenu,
  WizardContentComponent,
  WizMenuChildComponent,
  WizardComponent,
  ThingsDetailsComponent,
  ClonePopupComponent,
  MapComponent,
  LocationAttributes,
  LocationDetailsComponent,
  LocationPopup,
  OfflineThresholdComponent
];



// WEBPACK FOOTER //
// ./src/app/things/things.routing.module.ts